import { Skeleton } from "@/components/ui/skeleton";

export const TableSkeleton = ({ rows = 5, cols = 5 }) => (
  <div className="space-y-3" data-testid="table-skeleton">
    {Array.from({ length: rows }).map((_, r) => (
      <div key={r} className="flex items-center gap-4">
        {Array.from({ length: cols }).map((_, c) => (
          <Skeleton key={c} className="h-10 flex-1" />
        ))}
      </div>
    ))}
  </div>
);

export const CardSkeleton = ({ count = 4 }) => (
  <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
    {Array.from({ length: count }).map((_, i) => (
      <Skeleton key={i} className="h-32 w-full rounded-xl" />
    ))}
  </div>
);

export default TableSkeleton;
